import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { BehaviorSubject, filter, take } from 'rxjs';
import { FuseNavigationService } from '../../../@fuse/components/navigation/navigation.service';
import { MapNavigationPermissions } from '../navigation-permission';

@Injectable({
  providedIn: 'root',
})
export class NavPermissionService {
  firstNavigationEnded = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly _fuseNavigationService: FuseNavigationService,
    private readonly _router: Router,
    private readonly _ngxPermissionService: NgxPermissionsService,
  ) {
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1),
      )
      .subscribe((event: any) => {
        // console.log('@@@ firstNavigationEnded', event);
        this.firstNavigationEnded.next(true);
        // this.firstNavigationEnded.complete();
      });
  }

  private async _isValidRoute(route: ActivatedRoute) {
    const routePermissions = route.snapshot.data?.permissions?.only || [];
    if (!routePermissions.length) return true;

    const hasPermission = await this._ngxPermissionService.hasPermission(routePermissions);
    return hasPermission;
  }

  async isValidCurrentRoute(): Promise<boolean> {
    let route = this._router.routerState.root;

    while (route) {
      const valid = await this._isValidRoute(route);

      if (!valid) return false;
      route = route.firstChild;
    }

    return true;
  }

  updateNavigationFromPermissions(grants: string[]) {
    //* const permsLog = [];
    const localPermissions = (JSON.parse(localStorage.getItem('allPermissions')) || []).map((x) => x.name);
    const filteredPermissions = localPermissions.filter((x) => !grants.includes(x));

    filteredPermissions.forEach((elem) => {
      // console.log('@@@ filteredPermissions field elem', elem);
      if (elem === 'canDevTools') {
        // console.log('@@@ updateNavigationFromPermissions elem canDevTools XXX');
      }
      if (Object.keys(MapNavigationPermissions).includes(elem)) {
        //* permsLog.push(MapNavigationPermissions[elem]);
        let sectionIds = MapNavigationPermissions[elem];
        if (!Array.isArray(sectionIds)) {
          sectionIds = [sectionIds];
        }
        sectionIds.forEach((sectionId) => {
          this._fuseNavigationService.updateNavigationItem(sectionId, {
            hidden: true,
          });
        });
        // console.log('@@@ updateNavigationFromPermissions HIDDEN', elem);
      } else {
        // console.log('@@@ updateNavigationFromPermissions VISIBLE', elem);
      }
    });
  }
}
